import { render, staticRenderFns } from "./DetalhesDadosGerais.vue?vue&type=template&id=0590e476"
import script from "./DetalhesDadosGerais.vue?vue&type=script&lang=ts"
export * from "./DetalhesDadosGerais.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports